import {
  Text,
  Loader,
  Modal as ModalMantine,
  useMantineTheme,
} from "@mantine/core";
import { useTranslation } from "react-i18next";

interface IProps {
  open: boolean;
}

const ModalLoading = ({ open }: IProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <ModalMantine
      onClose={() => {}}
      opened={open}
      transitionProps={{
        exitDuration: 600,
        transition: "slide-up",
        duration: 600,
        timingFunction: "ease",
      }}
      closeOnClickOutside={false}
      centered={true}
      styles={{
        content: {
          background: theme.colors.primaryOpacity[1],
          borderRadius: " 12px",
        },
        header: {
          marginBottom: "0",
          background: "transparent",
          height: "129px",
        },
        close: {
          display: "none",
        },
        body: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#fff",
          borderRadius: "50px 50px 12px 12px",
          padding: "0 40px 0 40px",
        },
      }}
    >
      <Loader size={60} mt="-100px" />
      <Text fw={600} fz="24px" lh="48xp" mt="60px">
        {t("global.modal.loading.validate")}
      </Text>
      <Text fw={600} fz="16px" lh="48px" color="basic.4" mb="32px">
        {t("global.modal.loading.purchase")}
      </Text>
    </ModalMantine>
  );
};

export default ModalLoading;
